<template>
<div class="chapter">
<div class="inner_page">
<p class="para"><a id="page_v"></a><a id="ded"></a>This book in the series is dedicated to the concept of redemption—that if we simply believe, we still have a fighting chance. Much has happened in the world since this series began. There are signs everywhere that we might all need to take heed and pursue a more spiritual path. The earth even stopped in time for microseconds after a disastrous tsunami. This tells me that there is a power out there greater than my tiny human brain could ever hope to conceive of, and therefore, anything is possible. But one thing I know for sure is redemption was a promise.</p>
<p class="indent-para">May you choose wisely and pause to think about things greater than we can fathom.</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// dedication.vue?0a602875